import { render } from "./WSOP.vue?vue&type=template&id=a264ab32"
import script from "./WSOP.vue?vue&type=script&lang=js"
export * from "./WSOP.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__